// src/translations/pages/impressum/en.js
import { injectPersonalData } from './impressumUtils.js';

const baseTranslationEN = {
  title: 'Legal Notice',
  subtitle: 'Information pursuant to § 5 DDG (Digital Services Act Germany)',
  
  serviceProvider: 'Service Provider',
  
  contactTitle: 'Contact',
  addressLabel: 'Address',
  contactLabel: 'E-Mail Address',
  
  professionalTitle: 'Company Information',
  professionLabel: 'Legal Form',
  businessTypeLabel: 'Type of Activity',
  
  taxTitle: 'Tax Information',
  
  liabilityTitle: 'Liability Notice',
  contentLiabilityTitle: 'Liability for Content',
  contentLiability: 'As service providers, we are liable for own contents of these websites according to Sec. 7, para.1 of the DDG. However, according to Sec. 8 to 10 of the DDG, we as service providers are not under obligation to monitor external information provided or stored on our website.',
  
  linkLiabilityTitle: 'Liability for Links',
  linkLiability: 'Our offer includes links to external third party websites. We have no influence on the contents of those websites, therefore we cannot guarantee for those contents. Providers or administrators of linked websites are always responsible for their own contents. The linked websites had been checked for possible violations of law at the time of the establishment of the link.',
  
  copyrightTitle: 'Copyright',
  copyright: 'Contents and compilations published on these websites by the providers are subject to German copyright laws. Reproduction, editing, distribution as well as the use of any kind outside the scope of the copyright law require a written permission of the author or originator. Downloads and copies of these websites are permitted for private use only.'
};

// Export the translation with injected personal data
export const impressumPageEN = injectPersonalData('en', baseTranslationEN);